<template>
    <li :class="['nav-item']">
        <router-link tag="a" class="nav-link d-flex justify-content-start" exact
                     :to="to"
                     v-if="$viewSidebar.isAllowed('viewLink', to.name)">
            <span :class="['icon', iconName]"></span>
            <span class="route-name">{{text}}</span>
        </router-link>
    </li>
</template>
<script type="text/babel">
import {SidebarPerimeter} from '../../../router/perimeters/sidebarPerimeter';

export default {
    name: 'cph-sidebar-navigation-link',
    props: {
        to: {
            type: [String, Object]
        },
        text: {
            type: String
        },
        iconName: {
            type: String
        }
    },
    perimeters: [
        SidebarPerimeter
    ]
};
</script>
<style lang="scss" scoped>
    a.nav-link {
        @include color('color', text-color-light);
        padding: 0 20px 0 8px;
        font-size: 1.2em;
        height: 38px;
        line-height: 38px;
        border-top: 1px solid;
        border-bottom: 1px solid;
        @include color('border-color', sidebar-link-border);

        margin-top: -1px;
        &.router-link-active {
            @include color('background-color', sidebar-link-active);

        }
        .icon {
            padding-top: 7px;
            padding-right: 25px;
            font-size: 1.4em;
            display: inline-block;
        }
    }


</style>
